import { useContext } from "react"
import { css } from "@emotion/core"
import RegisterableContext from "components/admin/registerable/context"
import SelectionGroup from "components/admin/registerable/SelectionGroup"
import SignupTimeSelections from "components/admin/registerable/SignupTimeSelections"
import { Pane } from "components/ui"
import { func } from "prop-types"

const Selections = ({ onSelectionsChange }) => {
  const {
    registerable: { attendeeTypeSelections }
  } = useContext(RegisterableContext)
  const showTimes = attendeeTypeSelections.some(({ signupTimeId }) => !!signupTimeId)

  return (
    <Pane marginBottom={2}>
      <Pane.Header>
        <Pane.Title>Selections</Pane.Title>
      </Pane.Header>
      <Pane.Body axis="vertical" paddingVertical={0} css={selectionsStyles}>
        {showTimes ? (
          <div className="newReservationWithSplitTimes">
            <SignupTimeSelections onSelectionsChange={onSelectionsChange} />
          </div>
        ) : (
          <div className="newReservationWithNoSplitTimes">
            <SelectionGroup
              onSelectionsChange={onSelectionsChange}
              selections={attendeeTypeSelections}
              className="selectionGroup"
            />
          </div>
        )}
      </Pane.Body>
    </Pane>
  )
}

Selections.propTypes = {
  onSelectionsChange: func.isRequired
}

const selectionsStyles = css`
  & .newReservationWithNoSplitTimes .selectionGroup .selectionList {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper {
    margin-top: 1rem;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper:last-child .signupTime {
    margin-bottom: 1rem;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper:last-child .signupTimeChecked {
    margin-bottom: 0;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper .selectionList {
    // margin-bottom: 1rem;
    margin-top: 1rem;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper:last-child .selectionList {
    margin-bottom: 1rem;
  }
  & .newReservationWithSplitTimes .signupTimeWrapper .selectionGroupWithSplitTimes .waitlistList {
    margin-top: 1rem;
  }
`

export default Selections
